import { getUserFullName } from '@/utils/user'
import {
  EPtoHandbookEstimateBaseTypeName,
  getEstimateBaseTypeKey
} from '@/api/pto'

export function mapJobItem (item) {
  return {
    id: item.id,
    job_type: item.job_type?.name,
    executor: getUserFullName(item.executor) || item.executor_contract?.long_name,
    description: item.description
  }
}

export function mapEstimateBaseTypeItem (item) {
  const key = getEstimateBaseTypeKey(item)

  return {
    value: item,
    name: EPtoHandbookEstimateBaseTypeName[key],
    key
  }
}
